import { faEnvelope, faLocationDot, faPhone} from '@fortawesome/free-solid-svg-icons';
import './index.scss'
import { faFacebook, faGithub, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import emailjs from '@emailjs/browser';

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import toast from 'react-hot-toast';
// ..
AOS.init();

export default function Footer(){
    return(
        <div className="footer-page"  data-aos="fade-up"
        data-aos-duration="4000">
            <footer className="footer">
                <div className='main-body'>
                    <div className='contact-details' data-aos="fade-left">
                        <h2>Details</h2>
                        <ul>
                            <li className=' w-fit'>
                                <div className='flex justify-center gap-2 items-center'>
                                    <FontAwesomeIcon icon={faPhone}/>
                                    <p className=' cursor-pointer' onClick={()=>navigator.clipboard.writeText('9482599734')}> 
                                        +91 9482599734
                                    </p>
                                </div>
                            </li>
                            <li >
                                <div className=' flex justify-center gap-2 items-center' >
                                    <FontAwesomeIcon icon={faEnvelope}/>
                                    <a href = "mailto: mohammedaslam4106@gmail.com">
                                        Contact Us
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div className=' flex justify-center gap-2 items-center'>
                                    <FontAwesomeIcon icon={faLocationDot} />
                                    <p>
                                        Davangere, Karnataka, India
                                    </p>
                                </div>
                            </li>
                            <ul>
                        <li><a href="https://github.com/MohammedAslam106" rel='noreferrer' target='_blank'><FontAwesomeIcon icon={faGithub} /></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=100041960631732" rel='noreferrer' target='_blank'><FontAwesomeIcon icon={faFacebook} /></a></li>
                        <li><a href="https://www.instagram.com/mohammedaslam4106/" rel='noreferrer' target='_blank'><FontAwesomeIcon icon={faInstagram}/></a></li>
                        <li><a href="https://twitter.com/Mohamme80786618" rel='noreferrer' target='_blank'><FontAwesomeIcon icon={faTwitter}/></a></li>
                        <li><a href="https://www.linkedin.com/in/mohammed-aslam-152b52217/" rel='noreferrer' target='_blank'><FontAwesomeIcon icon={faLinkedin}/></a></li>
                    </ul>
                        </ul>
                    </div>

                    <div className="contents" data-aos="fade-left">
                        <h2>Contents</h2>
                        <ul>
                            <li>
                            <a href="/">Home</a>
                            </li>
                            <li>
                            <a href="/about">About</a>
                            </li>
                            <li>
                            <a href="/contact">Contact</a>
                            </li>
                            <li>
                            <a href="/projects">Projects</a>
                            </li>
                            <li>
                            <a href="/resume">Resume</a>
                            </li>
                        </ul>
                    </div>
                    
                    <div className='contact' data-aos="fade-up">
                        <h2>Contact Form</h2>
                        <form onSubmit={(e)=>{
                            e.preventDefault()
                            // console.log(e.currentTarget)
                            emailjs.sendForm(
                                'service_tpd3rtc',
                                'template_7pe22k9',
                                e.currentTarget,
                                'H55MmNSwhjdaTKKcT'
                            ).then(res=>{
                                if(res.status===200){
                                    toast.success('Thanks for contacting..')
                                }
                                else{
                                    toast.error('Try Again!')
                                }
                            })
                        }} id='form-1'>
                            <ul>
                                <li className='inp'>
                                    <input required name='from_name' type="text" placeholder='Name' />
                                    <input required name='form_eamil' type="email" placeholder='E-mail' />
                                </li>
                                <li className='text'>
                                    <textarea required placeholder='message' name="message" ></textarea>
                                </li>
                            </ul>
                        </form>
                        <button className='btn' form='form-1' type="submit">Submit</button>
                    </div>
                </div>
            </footer>
        </div>
    )
}